import { ANALYTICS } from '../../constants/common';
import { trackFormInput, trackFormWorkFlow } from './analyticEvents';

/**
 * @method trackBoostContentInitiate
 * @description this method tracks boost content initiate action
 */
export const trackBoostContentInitiate = () => {
  // Form initiation tracking
  trackFormWorkFlow(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackBoostContentAppliedRecommendationCount
 * @description this method tracks the count of applied recommendations in boost content
 * @param {number} appliedRecommendationCount (applied recommendation count) [number of recommendations applied]
 * @param {string} userEncodedNtid (user encoded ntid) [user encoded ntid for tracking purposes]
 */
export const trackBoostContentAppliedRecommendationCount = (
  appliedRecommendationCount: number,
  userEncodedNtid: string
) => {
  trackFormInput(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.STEP,
    ANALYTICS.APPLIED_RECOMMENDATION_COUNT_QUESTION_NAME,
    appliedRecommendationCount.toString(),
    '1'
  );

  if (userEncodedNtid !== '') {
    trackFormInput(
      ANALYTICS.BOOST_CONTENT_FORM_NAME,
      ANALYTICS.STEP,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '2'
    );
  }
};

/**
 * @method trackBoostContentComplete
 * @description this method tracks boost content completion
 */
export const trackBoostContentComplete = () => {
  // Form completion tracking
  trackFormWorkFlow(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.FORM_ACTION.COMPLETED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackBoostContentError
 * @description this method tracks boost content errors
 */
export const trackBoostContentError = () => {
  // Form error tracking
  trackFormWorkFlow(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.FORM_ACTION.ERROR,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};
